if (!customElements.get('swatch-builder-v2')) {
  class SwatchBuilderV2 extends HTMLElement {
    constructor() {
      super();
      // Existing Bindings
      this._onTabClick = this._onTabClick.bind(this);
      this._onCheckboxChange = this._onCheckboxChange.bind(this);
      this._onSlotClick = this._onSlotClick.bind(this);
      this._onSubmitClick = this._onSubmitClick.bind(this);
      this._onPackChange = this._onPackChange.bind(this);
      this._onSwitchLink = this._onSwitchLink.bind(this);
      this._onPackSubmit = this._onPackSubmit.bind(this);
      this._onCuratedProductChange = this._onCuratedProductChange.bind(this);
      this._onZoomClick = this._onZoomClick.bind(this);
      this._onZoomAction = this._onZoomAction.bind(this);
      this._onZoomDialogClick = this._onZoomDialogClick.bind(this);

      // New Gallery Bindings
      this._onThumbClick = this._onThumbClick.bind(this);
      this._onPrevClick = this._onPrevClick.bind(this);
      this._onNextClick = this._onNextClick.bind(this);
      
      this.currentSlideIndex = 0;
    }

    connectedCallback() {
      this.limit = parseInt(this.dataset.limit, 10) || 5;
      this.tabs = this.querySelectorAll('[data-tab]');
      this.collections = this.querySelectorAll('[data-collection-id]');
      this.checkboxes = this.querySelectorAll('input[name="swatch"]');
      this.slotsContainer = this.querySelector('[data-swatch-slots]');
      this.countDisplay = this.querySelector('[data-selected-count]');
      this.submitButton = this.querySelector('[data-submit-swatches]');
      this.packToggles = this.querySelectorAll('.swatch-builder__toggle-btn');
      this.switchLinks = this.querySelectorAll('[data-set-mode]');
      this.packOptions = this.querySelectorAll('.swatch-builder__pack-option');
      this.buildView = this.querySelector('[data-build-view]');
      this.curatedView = this.querySelector('[data-curated-view]');
      this.packSubmit = this.querySelector('[data-pack-submit]');
      this.zoomButtons = this.querySelectorAll('[data-swatch-zoom]');
      this.zoomDialog = this.querySelector('[data-zoom-dialog]');

      // Gallery & Curated Elements
      this.thumbsContainer = this.querySelector('[data-gallery-thumbs]');
      this.slidesContainer = this.querySelector('[data-gallery-slides]');
      this.prevBtn = this.querySelector('[data-gallery-prev]');
      this.nextBtn = this.querySelector('[data-gallery-next]');
      this.packTitle = this.querySelector('[data-pack-title]');
      this.packPrice = this.querySelector('[data-pack-price]');
      
      // Parse JSON data
      const jsonEl = this.querySelector('[data-curated-packs-json]');
      this.packsData = jsonEl ? JSON.parse(jsonEl.textContent) : [];

      // Event Listeners
      this.packOptions.forEach(option =>
        option.addEventListener('click', this._onCuratedProductChange)
      );
      this.tabs.forEach(tab => tab.addEventListener('click', this._onTabClick));
      this.checkboxes.forEach(cb => cb.addEventListener('change', this._onCheckboxChange));
      this.packToggles.forEach(btn => btn.addEventListener('click', this._onPackChange));
      this.switchLinks.forEach(link => link.addEventListener('click', this._onSwitchLink));
      if (this.packSubmit) this.packSubmit.addEventListener('click', this._onPackSubmit);
      this.zoomButtons.forEach(btn => btn.addEventListener('click', this._onZoomClick));
      if (this.zoomDialog) {
        this.zoomDialog.addEventListener('click', this._onZoomDialogClick);
        this.zoomDialog.querySelector('[data-zoom-action]').addEventListener('click', this._onZoomAction);
      }

      if (this.slotsContainer) this.slotsContainer.addEventListener('click', this._onSlotClick);
      if (this.submitButton) this.submitButton.addEventListener('click', this._onSubmitClick);
      if (this.thumbsContainer) this.thumbsContainer.addEventListener('click', this._onThumbClick);
      if (this.prevBtn) this.prevBtn.addEventListener('click', this._onPrevClick);
      if (this.nextBtn) this.nextBtn.addEventListener('click', this._onNextClick);

      this._updateState();
    }

    disconnectedCallback() {
      // Existing cleanup
      this.tabs.forEach(tab => tab.removeEventListener('click', this._onTabClick));
      this.checkboxes.forEach(cb => cb.removeEventListener('change', this._onCheckboxChange));
      this.packToggles.forEach(btn => btn.removeEventListener('click', this._onPackChange));
      this.switchLinks.forEach(link => link.removeEventListener('click', this._onSwitchLink));
      if (this.packSubmit) this.packSubmit.removeEventListener('click', this._onPackSubmit);
      this.zoomButtons.forEach(btn => btn.removeEventListener('click', this._onZoomClick));
      if (this.zoomDialog) {
        this.zoomDialog.removeEventListener('click', this._onZoomDialogClick);
        this.zoomDialog.querySelector('[data-zoom-action]').removeEventListener('click', this._onZoomAction);
      }
      this.packOptions.forEach(option =>
        option.removeEventListener('click', this._onCuratedProductChange)
      );
      if (this.slotsContainer) this.slotsContainer.removeEventListener('click', this._onSlotClick);
      if (this.submitButton) this.submitButton.removeEventListener('click', this._onSubmitClick);
      
      // New Gallery cleanup
      if (this.thumbsContainer) this.thumbsContainer.removeEventListener('click', this._onThumbClick);
      if (this.prevBtn) this.prevBtn.removeEventListener('click', this._onPrevClick);
      if (this.nextBtn) this.nextBtn.removeEventListener('click', this._onNextClick);
    }

    _onZoomClick(e) {
      const btn = e.currentTarget;
      const checkbox = document.getElementById(btn.dataset.inputId);
      if (!checkbox || !this.zoomDialog) return;

      this.zoomCheckbox = checkbox;
      const image = this.zoomDialog.querySelector('[data-zoom-image]');
      image.src = btn.dataset.fullSrc;
      image.alt = checkbox.dataset.title || '';
      this.zoomDialog.querySelector('[data-zoom-title]').textContent = checkbox.dataset.title || '';
      this._syncZoomAction();
      this.zoomDialog.showModal();
    }

    _onZoomDialogClick(e) {
      // Backdrop clicks target the dialog element itself
      if (e.target === this.zoomDialog || e.target.closest('[data-zoom-close]')) {
        this.zoomDialog.close();
      }
    }

    _onZoomAction() {
      const checkbox = this.zoomCheckbox;
      if (!checkbox || checkbox.disabled) return;
      checkbox.checked = !checkbox.checked;
      checkbox.dispatchEvent(new Event('change', { bubbles: true }));
      this.zoomDialog.close();
    }

    _syncZoomAction() {
      const action = this.zoomDialog.querySelector('[data-zoom-action]');
      const checkbox = this.zoomCheckbox;
      action.textContent = checkbox.checked ? this.zoomDialog.dataset.removeLabel : this.zoomDialog.dataset.addLabel;
      action.disabled = checkbox.disabled;
    }

    _onCuratedProductChange(e) {
      const option = e.currentTarget;
      const input = option.querySelector('input[type="radio"]');

      if (!input) return;

      // Ensure the radio is selected
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));

      // Update selected styling
      this.packOptions.forEach(opt => {
        opt.classList.remove('swatch-builder__pack-option--selected');
      });

      option.classList.add('swatch-builder__pack-option--selected');

      // Pull new pack data and rebuild gallery
      const variantId = parseInt(input.value, 10);
      const packData = this.packsData.find(p => p.variantId === variantId);

      if (packData) {
        if (this.packTitle) this.packTitle.textContent = packData.title;
        if (this.packPrice) this.packPrice.textContent = packData.priceFormatted;
        this._rebuildGallery(packData);
      }
    }

_rebuildGallery(packData) {
      this.currentSlideIndex = 0;

      // Rebuild Thumbs
      if (this.thumbsContainer && packData.images) {
        this.thumbsContainer.innerHTML = packData.images.map((img, idx) => `
          <button
            type="button"
            class="swatch-builder__gallery-thumb${idx === 0 ? ' swatch-builder__gallery-thumb--active' : ''}"
            data-thumb-index="${idx}"
            aria-label="${img.alt}"
          >
            <img src="${img.thumb}" alt="${img.alt}" loading="lazy">
          </button>
        `).join('');
      }

      // Rebuild Slides (Removed the hidden class logic)
      if (this.slidesContainer && packData.images) {
        this.slidesContainer.innerHTML = packData.images.map((img, idx) => `
          <div class="swatch-builder__gallery-slide" data-slide-index="${idx}">
            <img src="${img.full}" alt="${img.alt}" loading="lazy">
          </div>
        `).join('');
        
        // Reset slide position for the new pack
        this.slidesContainer.style.transform = `translateX(0%)`;
      }
    }

    _onThumbClick(e) {
      const thumbBtn = e.target.closest('[data-thumb-index]');
      if (!thumbBtn) return;
      this.currentSlideIndex = parseInt(thumbBtn.dataset.thumbIndex, 10);
      this._updateGalleryUI();
    }

    _onPrevClick() {
      const totalSlides = this.slidesContainer.querySelectorAll('[data-slide-index]').length;
      if (totalSlides === 0) return;
      this.currentSlideIndex = (this.currentSlideIndex - 1 + totalSlides) % totalSlides;
      this._updateGalleryUI();
    }

    _onNextClick() {
      const totalSlides = this.slidesContainer.querySelectorAll('[data-slide-index]').length;
      if (totalSlides === 0) return;
      this.currentSlideIndex = (this.currentSlideIndex + 1) % totalSlides;
      this._updateGalleryUI();
    }

    _updateGalleryUI() {
      const thumbs = this.thumbsContainer.querySelectorAll('[data-thumb-index]');
      
      // Update Thumbs Active State
      thumbs.forEach((thumb, idx) => {
        thumb.classList.toggle('swatch-builder__gallery-thumb--active', idx === this.currentSlideIndex);
      });

      // Slide the Gallery Track
      if (this.slidesContainer) {
        this.slidesContainer.style.transform = `translateX(-${this.currentSlideIndex * 100}%)`;
      }
    }

    // --- The rest are your original unmodified methods ---

    _onTabClick(e) {
      const tab = e.currentTarget;
      const tabId = tab.dataset.tab;

      this.tabs.forEach(t => {
        t.classList.toggle('swatch-builder__tab--active', t === tab);
        t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
      });

      this.collections.forEach(c => {
        if (tabId === 'all') {
          c.removeAttribute('hidden');
        } else {
          if (c.dataset.collectionId === tabId) {
            c.removeAttribute('hidden');
          } else {
            c.setAttribute('hidden', '');
          }
        }
      });
    }

    _onCheckboxChange(e) {
      const checkbox = e.target;
      if (checkbox.checked) {
        this._addItem(checkbox);
      } else {
        this._removeItem(checkbox);
      }
      this._updateState();
    }

    _onSlotClick(e) {
      const removeBtn = e.target.closest('.swatch-builder__slot-remove');
      if (!removeBtn) return;

      const variantId = removeBtn.dataset.variantId;
      const checkbox = this.querySelector(`input[name="swatch"][value="${variantId}"]`);
      if (checkbox) {
        checkbox.checked = false;
        this._removeItem(checkbox);
        this._updateState();
      }
    }

    _onSubmitClick(e) {
      if (this.submitButton.tagName === 'BUTTON') {
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
      }
    }

    _onPackChange(e) {
      this._setMode(e.currentTarget.dataset.toggleMode);
    }

    _onSwitchLink(e) {
      e.preventDefault();
      this._setMode(e.currentTarget.dataset.setMode);
    }

    _onPackSubmit(e) {
      const selected = this.querySelector('input[name="id"]:checked');
      const variantId = selected ? parseInt(selected.value, 10) : NaN;
      if (isNaN(variantId)) return;

      e.preventDefault();
      const cartUrl = this.packSubmit.dataset.cartUrl;
      const routes = window.FoxTheme?.routes || {};

      fetch(routes.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      })
        .then(r => r.json())
        .then(() => {
          if (cartUrl) {
            window.location.href = cartUrl;
          } else {
            this._refreshCart();
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
          }
        })
        .catch(() => {});
    }

    _setMode(mode) {
      if (mode !== 'build' && mode !== 'curated') return;

      this.packToggles.forEach(btn => {
        btn.classList.toggle('swatch-builder__toggle-btn--active', btn.dataset.toggleMode === mode);
      });

      const showCurated = mode === 'curated';
      this.buildView?.toggleAttribute('hidden', showCurated);
      this.curatedView?.toggleAttribute('hidden', !showCurated);
    }

    _updateState() {
      const selected = this.querySelectorAll('input[name="swatch"]:checked');
      const count = selected.length;

      if (this.countDisplay) this.countDisplay.textContent = count;
      if (this.submitButton) {
        if (this.submitButton.tagName === 'BUTTON') {
          this.submitButton.disabled = count === 0;
        } else {
          this.submitButton.classList.toggle('swatch-builder__sidebar-btn--disabled', count === 0);
        }
      }

      if (count >= this.limit) {
        this.checkboxes.forEach(cb => {
          if (!cb.checked) cb.disabled = true;
        });
      } else {
        this.checkboxes.forEach(cb => {
          if (!cb.dataset.unavailable) cb.disabled = false;
        });
      }

      this._renderSlots(selected);
    }

    _renderSlots(selected) {
      if (!this.slotsContainer) return;
      const slots = this.slotsContainer.querySelectorAll('[data-slot]');

      slots.forEach((slot, i) => {
        slot.innerHTML = '';

        if (selected[i]) {
          const cb = selected[i];
          const src = cb.dataset.thumbSrc;
          const title = cb.dataset.title || '';

          slot.className = 'swatch-builder__slot swatch-builder__slot--filled no-empty';

          if (src) {
            const img = document.createElement('img');
            img.src = src;
            img.alt = title;
            img.width = 48;
            img.height = 48;
            img.loading = 'lazy';
            slot.appendChild(img);
          }

          const removeBtn = document.createElement('button');
          removeBtn.type = 'button';
          removeBtn.className = 'swatch-builder__slot-remove';
          removeBtn.setAttribute('aria-label', 'Remove ' + title);
          removeBtn.dataset.variantId = cb.value;
          removeBtn.textContent = '×';
          slot.appendChild(removeBtn);
        } else {
          slot.className = 'swatch-builder__slot swatch-builder__slot--empty no-empty';
        }
      });
    }

    _addItem(checkbox) {
      checkbox.dataset.inCart = 'true';
      const routes = window.FoxTheme?.routes || {};
      fetch(routes.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{
            id: parseInt(checkbox.value, 10),
            quantity: 1,
            properties: { __swatch: true },
          }],
        }),
      })
        .then(r => r.json())
        .then(() => this._refreshCart())
        .catch(() => {
          checkbox.checked = false;
          delete checkbox.dataset.inCart;
          this._updateState();
        });
    }

    _removeItem(checkbox) {
      delete checkbox.dataset.inCart;
      const routes = window.FoxTheme?.routes || {};
      fetch((routes.cart_change_url || '/cart/change.js') + '?id=' + checkbox.value + '&quantity=0', {
        headers: { Accept: 'application/json' },
      })
        .then(r => r.json())
        .then(() => this._refreshCart())
        .catch(() => {
          checkbox.checked = true;
          checkbox.dataset.inCart = 'true';
          this._updateState();
        });
    }

    _refreshCart() {
      const routes = window.FoxTheme?.routes || {};
      fetch((routes.cart_url || '/cart') + '.js', {
        headers: { Accept: 'application/json' },
      })
        .then(r => r.json())
        .then(cart => {
          if (window.FoxTheme?.pubsub) {
            FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart });
          }
        })
        .finally(() => {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        });
    }
  }

  customElements.define('swatch-builder-v2', SwatchBuilderV2);
}